<template>
  <path d="M15.075 8.172v1.657c0 0.457-0.371 0.828-0.828 0.828h-3.59v3.59c0 0.457-0.371 0.828-0.828 0.828h-1.657c-0.457 0-0.828-0.371-0.828-0.828v-3.59h-3.59c-0.457 0-0.828-0.371-0.828-0.828v-1.657c0-0.457 0.371-0.828 0.828-0.828h3.59v-3.59c0-0.457 0.371-0.828 0.828-0.828h1.657c0.457 0 0.828 0.371 0.828 0.828v3.59h3.59c0.457 0 0.828 0.371 0.828 0.828z"></path>
</template>
